import { useFormStore } from "@/widgets/classic-form/form";
import type { Relations } from "@/entities/data-model";

const familyRelationsAreExact = (events: Relations) =>
    Object.values(events).every((event) => {
        if (!event.instances.length) return true;
        return event.instances.every((instance) => {
            const givenNameExact = instance.givenNameExactness?.isExact;
            const surnameExact = instance.surnameExactness?.isExact;
            return givenNameExact && surnameExact;
        });
    });

export const useFamilyExactness = () => {
    const isExact = useFormStore((store) => familyRelationsAreExact(store.values.family));
    return isExact;
};
